// import React, { useState } from 'react';
// import { Link, useNavigate } from 'react-router-dom';
// import { useForm } from 'react-hook-form';
// import { useAuth } from '../context/AuthContext';
// import OTPInput from '../components/OTPInput';
// import LoadingSpinner from '../components/LoadingSpinner';

// const Login = () => {
//   const { register, handleSubmit, formState: { errors } } = useForm();
//   const { login, verifyOTP } = useAuth();
//   const navigate = useNavigate();
//   const [loading, setLoading] = useState(false);
//   const [otpRequired, setOtpRequired] = useState(false);
//   const [userId, setUserId] = useState(null);

//   const onSubmit = async (data) => {
//     setLoading(true);
//     try {
//       const result = await login(data.mobileNumber, data.password);
//       if (result.requiresVerification) {
//         setOtpRequired(true);
//         setUserId(result.userId);
//       } else {
//         navigate('/dashboard');
//       }
//     } catch (error) {
//       console.error('Login error:', error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleOTPComplete = async (otp) => {
//     setLoading(true);
//     try {
//       await verifyOTP(userId, otp);
//       navigate('/dashboard');
//     } catch (error) {
//       console.error('OTP verification error:', error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   if (otpRequired) {
//     return (
//       <div className="min-h-screen flex items-center justify-center bg-gray-50">
//         <div className="max-w-md w-full space-y-8">
//           <div className="text-center">
//             <h2 className="mt-6 text-3xl font-extrabold text-gray-900">
//               Verify OTP
//             </h2>
//             <p className="mt-2 text-sm text-gray-600">
//               We've sent a verification code to your mobile number
//             </p>
//           </div>
//           <div className="mt-8 space-y-6">
//             <OTPInput onComplete={handleOTPComplete} />
//             {loading && (
//               <div className="flex justify-center">
//                 <LoadingSpinner />
//               </div>
//             )}
//           </div>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="min-h-screen flex items-center justify-center bg-gray-200">
//       <div className="max-w-md w-full space-y-8">
//         <div>
//           <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">
//             Sign in to your account
//           </h2>
//           <p className="mt-2 text-center text-sm text-gray-600">
//             Or{' '}
//             <Link to="/signup" className="font-medium text-primary-600 hover:text-primary-500">
//               create a new account
//             </Link>
//           </p>
//         </div>
//         <form className="mt-8 space-y-6" onSubmit={handleSubmit(onSubmit)}>
//           <div className="rounded-md shadow-sm -space-y-px">
//             <div>
//               <label htmlFor="mobileNumber" className="sr-only">
//                 Mobile Number
//               </label>
//               <input
//                 {...register('mobileNumber', { 
//                   required: 'Mobile number is required',
//                   pattern: {
//                     value: /^[0-9]{10}$/,
//                     message: 'Please enter a valid 10-digit mobile number'
//                   }
//                 })}
//                 type="tel"
//                 className="appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-t-md focus:outline-none focus:ring-primary-500 focus:border-primary-500 focus:z-10 sm:text-sm"
//                 placeholder="Mobile Number"
//               />
//               {errors.mobileNumber && (
//                 <p className="mt-1 text-sm text-red-600">{errors.mobileNumber.message}</p>
//               )}
//             </div>
//             <div>
//               <label htmlFor="password" className="sr-only">
//                 Password
//               </label>
//               <input
//                 {...register('password', { required: 'Password is required' })}
//                 type="password"
//                 className="appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-b-md focus:outline-none focus:ring-primary-500 focus:border-primary-500 focus:z-10 sm:text-sm"
//                 placeholder="Password"
//               />
//               {errors.password && (
//                 <p className="mt-1 text-sm text-red-600">{errors.password.message}</p>
//               )}
//             </div>
//           </div>

//           <div>
//             <button
//               type="submit"
//               disabled={loading}
//               className="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-primary-600 hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500 disabled:opacity-50"
//             >
//               {loading ? <LoadingSpinner size="small" /> : 'Sign in'}
//             </button>
//           </div>
//         </form>
//       </div>
//     </div>
//   );
// };

// export default Login;


import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { useAuth } from '../context/AuthContext';
import OTPInput from '../components/OTPInput';
import LoadingSpinner from '../components/LoadingSpinner';

const Login = () => {
  const { register, handleSubmit, formState: { errors } } = useForm();
  const { login, verifyOTP } = useAuth();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [otpRequired, setOtpRequired] = useState(false);
  const [userId, setUserId] = useState(null);

  const onSubmit = async (data) => {
    setLoading(true);
    try {
      const result = await login(data.mobileNumber, data.password);
      if (result.requiresVerification) {
        setOtpRequired(true);
        setUserId(result.userId);
      } else {
        navigate('/dashboard');
      }
    } catch (error) {
      console.error('Login error:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleOTPComplete = async (otp) => {
    setLoading(true);
    try {
      await verifyOTP(userId, otp);
      navigate('/dashboard');
    } catch (error) {
      console.error('OTP verification error:', error);
    } finally {
      setLoading(false);
    }
  };

  if (otpRequired) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="max-w-md w-full space-y-8">
          <div className="text-center">
            <h2 className="mt-6 text-3xl font-extrabold text-gray-900">
              Verify OTP
            </h2>
            <p className="mt-2 text-sm text-gray-600">
              We've sent a verification code to your mobile number
            </p>
          </div>
          <div className="mt-8 space-y-6">
            <OTPInput onComplete={handleOTPComplete} />
            {loading && (
              <div className="flex justify-center">
                <LoadingSpinner />
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-200">
      <div className="max-w-md w-full space-y-8">
        <div>
          <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">
            Sign in to your account
          </h2>
          <p className="mt-2 text-center text-sm text-gray-600">
            Or{' '}
            <Link to="/signup" className="font-medium text-primary-600 hover:text-primary-500">
              create a new account
            </Link>
          </p>
        </div>
        <form className="mt-8 space-y-6" onSubmit={handleSubmit(onSubmit)}>
          <div className="rounded-md shadow-sm -space-y-px">
            <div>
              <label htmlFor="mobileNumber" className="sr-only">
                Mobile Number
              </label>
              <input
                {...register('mobileNumber', { 
                  required: 'Mobile number is required',
                  pattern: {
                    value: /^[0-9]{10}$/,
                    message: 'Please enter a valid 10-digit mobile number'
                  }
                })}
                type="tel"
                className="appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-t-md focus:outline-none focus:ring-primary-500 focus:border-primary-500 focus:z-10 sm:text-sm"
                placeholder="Mobile Number"
              />
              {errors.mobileNumber && (
                <p className="mt-1 text-sm text-red-600">{errors.mobileNumber.message}</p>
              )}
            </div>
            <div>
              <label htmlFor="password" className="sr-only">
                Password
              </label>
              <input
                {...register('password', { required: 'Password is required' })}
                type="password"
                className="appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-b-md focus:outline-none focus:ring-primary-500 focus:border-primary-500 focus:z-10 sm:text-sm"
                placeholder="Password"
              />
              {errors.password && (
                <p className="mt-1 text-sm text-red-600">{errors.password.message}</p>
              )}
            </div>
          </div>

          <div className="flex items-center justify-between">
            <div />
            <div className="text-sm">
              <Link
                to="/forgot-password"
                className="font-medium text-primary-600 hover:text-primary-500"
              >
                Forgot password?
              </Link>
            </div>
          </div>

          <div>
            <button
              type="submit"
              disabled={loading}
              className="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-primary-600 hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500 disabled:opacity-50"
            >
              {loading ? <LoadingSpinner size="small" /> : 'Sign in'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Login;
